import actions from './actions';
import mutations from './mutations';

const state = {
  isActive: false,
  queue: []
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
